import React from 'react'

import { Typography } from '@mui/material'
import { SxProps, Theme } from '@mui/material/styles'

interface ChartDescriptionProps {
  children: React.ReactNode
  sx?: SxProps<Theme>
}

/**
 * The one-line explanation that sits under every Live Event Analytics chart
 * title: what the plotted number is and how it is measured. Every chart renders
 * it the same way so a reader learns once where to look for the definition
 * (2026-09-07 review: "consistent descriptive text under all charts").
 */
export const ChartDescription: React.FC<ChartDescriptionProps> = ({ children, sx }) => (
  <Typography component="p" variant="caption" color="text.secondary" sx={[{ display: 'block', mt: 0.25 }, ...(Array.isArray(sx) ? sx : [sx])]}>
    {children}
  </Typography>
)
